export default __webpack_public_path__ + "static/media/Sichuan-Da-County-2-poinrt5.8350e8b8.jpg";